import { Button, Flex, Text } from "@/atoms"
import useServices from "@/hooks/useServices"
import { Heading } from "@/molecules/Heading"

import styles from "./NextStepsTabAdr.module.scss"

import type { NextStepsTabAdrProps } from "."

export const Step = (props: NextStepsTabAdrProps) => {
  const { title, description, action } = props
  const { auth } = useServices()

  return (
    <Flex align="end" justify="space-between" className={styles.step}>
      <Flex vertical>
        <Heading capitalize={false} level={6} title={title} />
        <Text>{description}</Text>
      </Flex>
      {!!action && <Button disabled={!auth.isDemo()}>{action}</Button>}
    </Flex>
  )
}
